import { useEffect, useState, useRef } from 'react';
import Navbar from '../components/Navbar';
import VolverAlPanel from '../components/VolverAlPanel';
import GraficaSensor from '../components/GraficaSensor';
import ResumenSensor from '../components/ResumenSensor';
import './LecturasTiempoReal.css';

const RANGOS = {
  '10min': 10,
  '1h': 60,
  '6h': 360,
  '24h': 1440
};

function LecturasTiempoReal() {
  const [datos, setDatos] = useState([]);
  const [rango, setRango] = useState('10min');
  const [sensoresSeleccionados, setSensoresSeleccionados] = useState([]);
  const [pisciculturaSeleccionada, setPisciculturaSeleccionada] = useState('');
  const [sensoresCargados, setSensoresCargados] = useState([]);
  const usuario = JSON.parse(localStorage.getItem('usuario'));
  const token = localStorage.getItem('token');

  const calcularRangoFechas = (minutosAtras) => {
    const ahora = new Date();
    const desde = new Date(ahora.getTime() - minutosAtras * 60000);
    return {
      desde: desde.toISOString(),
      hasta: ahora.toISOString()
    };
  };

  const fetchSensores = async () => {
    try {
      const res = await fetch('https://iacloud.iapatagonia.cl/backend/sensores', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      setSensoresCargados(data);
    } catch (error) {
      console.error('Error al obtener sensores:', error);
    }
  };

  const fetchHistorico = async () => {
    if (sensoresSeleccionados.length === 0) return;
    const { desde, hasta } = calcularRangoFechas(RANGOS[rango]);
    const ids = sensoresSeleccionados.join(',');

    try {
      const res = await fetch(`https://iacloud.iapatagonia.cl/backend/lecturas/historicas?sensor_id=${ids}&desde=${desde}&hasta=${hasta}`);
      const data = await res.json();
      setDatos(data);
    } catch (error) {
      console.error('Error al cargar datos históricos:', error);
    }
  };

  const fetchUltimos = async () => {
    try {
      const res = await fetch(`https://iacloud.iapatagonia.cl/backend/lecturas/ultimas`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const nuevos = await res.json();

      setDatos((prev) => {
        const prevMap = new Map(prev.map(d => [`${d.IdSensor}-${d.FechaHora}`, d]));
        nuevos.forEach(d => {
          const key = `${d.IdSensor}-${d.FechaHora}`;
          if (!prevMap.has(key)) prevMap.set(key, d);
        });
        return Array.from(prevMap.values());
      });
    } catch (error) {
      console.error('Error al actualizar en tiempo real:', error);
    }
  };

  useEffect(() => {
    fetchSensores();
  }, []);

  useEffect(() => {
    fetchHistorico();
    const interval = setInterval(fetchUltimos, 1000);
    return () => clearInterval(interval);
  }, [sensoresSeleccionados, rango]);

  const pisciculturasDisponibles = [...new Set(sensoresCargados.map(s => s.Piscicultura).filter(Boolean))];

  const sensoresFiltradosPorPiscicultura = sensoresCargados.filter(s =>
    !pisciculturaSeleccionada || s.Piscicultura === pisciculturaSeleccionada
  );

  useEffect(() => {
    setSensoresSeleccionados(prev =>
      prev.filter(id => sensoresFiltradosPorPiscicultura.some(s => s.IdSensor === id))
    );
  }, [pisciculturaSeleccionada, sensoresCargados]);

  const datosFiltrados = datos.filter(d =>
    (sensoresSeleccionados.length === 0 || sensoresSeleccionados.includes(d.IdSensor)) &&
    (!pisciculturaSeleccionada || d.Piscicultura === pisciculturaSeleccionada)
  );

  const tiposDisponibles = [...new Set(datosFiltrados.map(d => d.Tipo).filter(Boolean))];

  return (
    <>
      <Navbar nombre={usuario.nombre_completo} rol={usuario.rol} />
      <VolverAlPanel />
      <div className="tiempo-container glass-card fadeIn slideUp">
        <h2 className="titulo">📡 Lecturas en Tiempo Real + Histórico</h2>

        <div className="filtros">
          <select value={pisciculturaSeleccionada} onChange={e => setPisciculturaSeleccionada(e.target.value)}>
            <option value="">Todas las Pisciculturas</option>
            {pisciculturasDisponibles.map(p => (
              <option key={p} value={p}>{p}</option>
            ))}
          </select>

          <div className="sensor-checkboxes">
            {sensoresFiltradosPorPiscicultura.map(s => (
              <label key={s.IdSensor} className="checkbox-item">
                <input
                  type="checkbox"
                  value={s.IdSensor}
                  checked={sensoresSeleccionados.includes(s.IdSensor)}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    setSensoresSeleccionados(prev =>
                      e.target.checked
                        ? [...prev, value]
                        : prev.filter(sid => sid !== value)
                    );
                  }}
                />
                <span>Sensor {String(s.IdSensor).padStart(2, '0')} - {s.TipoSensor}</span>
              </label>
            ))}
          </div>

          <select value={rango} onChange={e => setRango(e.target.value)}>
            {Object.keys(RANGOS).map(r => (
              <option key={r} value={r}>Últimos {r}</option>
            ))}
          </select>
        </div>

        {datosFiltrados.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#888', marginTop: '2rem' }}>
            No hay lecturas para el rango seleccionado.
          </p>
        ) : (
          <div className="graficas-row">
            {tiposDisponibles.map(tipo => (
              <div key={tipo} className="grafica-card">
                <h4>{tipo.charAt(0).toUpperCase() + tipo.slice(1)}</h4>
                <GraficaSensor datos={datosFiltrados.filter(d => d.Tipo === tipo)} tipo={tipo} />
                <ResumenSensor datos={datosFiltrados.filter(d => d.Tipo === tipo)} tipo={tipo} />
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}

export default LecturasTiempoReal;
